import React from 'react';
import { Droplet } from 'lucide-react';
export function Footer() {
  return <footer className="py-10 px-4 bg-slate-950 text-center border-t border-slate-800" role="contentinfo" data-id="element-95">
      <div className="max-w-3xl mx-auto" data-id="element-96">
        <Droplet className="w-8 h-8 text-orange-500 mx-auto mb-4" strokeWidth={1.5} aria-hidden="true" data-id="element-97" />
        <p className="text-white font-bold text-lg mb-4" data-id="element-98">
          💧 SISTEMA HUMEDAD CERO
        </p>

        <p className="text-xl font-serif font-bold text-white italic mb-8" data-id="element-99">
          "Desde hoy, tu casa tiene sistema."
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-slate-500 text-sm mb-6" data-id="element-100">
          <a href="#" className="hover:text-orange-500 transition-colors" data-id="element-101">
            📧 soporteoficialfegion@gmail.com
          </a>
          <a href="#" className="hover:text-orange-500 transition-colors" data-id="element-102">
            📲 @fegion1
          </a>
          <a href="#" className="hover:text-orange-500 transition-colors" data-id="element-103">
            🌐 www.fegion.shop
          </a>
        </div>

        <p className="text-slate-600 text-xs" data-id="element-104">
          © Sistema Humedad Cero 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}